import React from 'react';
import {
  ModalOverlay,
  ModalDialog,
  ModalTitle,
  ModalMessage,
  ModalButtonGroup,
  ModalButton,
} from '../styles/modal';

interface LogoutConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const LogoutConfirmDialog: React.FC<LogoutConfirmDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => (
  <ModalOverlay $isOpen={isOpen} onClick={onCancel}>
    <ModalDialog onClick={e => e.stopPropagation()}>
      <ModalTitle>Confirm Logout</ModalTitle>
      <ModalMessage>Are you sure you want to logout from your account?</ModalMessage>
      <ModalButtonGroup>
        <ModalButton onClick={onCancel}>Cancel</ModalButton>
        <ModalButton $primary onClick={onConfirm}>
          Yes, Logout
        </ModalButton>
      </ModalButtonGroup>
    </ModalDialog>
  </ModalOverlay>
);

export default LogoutConfirmDialog;
